/**
 * Optionally has year
 */
export interface PrizmYearLike {
  readonly year?: number;
}
